import AudioFileUpdateRequest from '../../../../../Spirit/Admin/Interfaces/Models/MusicService/AudioFileUpdateRequest';
import TranslationModel from '../../../../../Spirit/Admin/Interfaces/Models/TranslationModel';
import CropAndSaveImageRequest from '../../../../../Spirit/Common/FileManager/Models/CropAndSaveImageRequest';

export default class AlbumUpdateRequest  {
	Id?: number = null;
	IsSleep: boolean = false;
	UseOnMainDisplay: boolean = false;
	AnimationId?: string = '';
	IsPaid: boolean = false;
	Audiofiles: Array<AudioFileUpdateRequest> = null;
	Translations: Array<TranslationModel> = null;
	Cover: CropAndSaveImageRequest = null;
	Back: CropAndSaveImageRequest = null;
	Categories: Array<number> = null;
	constructor(obj?: Partial<AlbumUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
